// extracted by mini-css-extract-plugin
export default {"form":"mtr2Q","field":"S7CLf","actions":"XTVFx","action":"t2MRG"};